import { Plugin } from '@segment/analytics-next'
import { parseCookies } from 'nookies'
import { getSessionId } from '../../services/AmplitudeService'

const extractGaClientId = () => {
  const gaCookieName = '_ga'
  const cookie = parseCookies()
  const gaCookie = cookie[gaCookieName]
  return gaCookie?.split('.').slice(-2).join('.') ?? null
}

const SegmentInjectOptionsPlugin: Plugin = {
  name: 'SegmentInjectOptionsPlugin',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: async ctx => {
    const gaClientId = extractGaClientId()
    if (gaClientId) {
      ctx.updateEvent('integrations.Google Analytics.clientId', gaClientId)
    }

    const amplitudeSessionId = await getSessionId(ctx.event.userId ?? '')
    if (amplitudeSessionId && ctx.event.userId) {
      ctx.updateEvent(
        'integrations.Actions Amplitude.session_id',
        amplitudeSessionId
      )
    }
    return ctx
  },
}

export default SegmentInjectOptionsPlugin
